<template>
	<div>
		<div :style="textStyle">
			<h5>
				<router-link :to="{ name: 'Dashboard' }">
					<i class="fas fa-angle-left" style="margin-right: 10px"></i></router-link>
				Sélection thématique
			</h5>
		</div>
		<div>
			<flickity v-if="this.thematics.length > 0" :options="flickityOptions">
				<div class="carousel-cell" v-for="(thematic, index) in thematics" v-bind:key="index">
					<a href="#">
						<div class="theme_card" v-bind:class="{ selected: thematic.isSelected }" v-on:click.prevent="getThematicId(index)">
							<div class="card-image">
								<img class="mx-auto d-block img_thematic" :src="thematic.img">
							</div>
							<div class="card-action-custom">
								<div class="row align-items-end">
									<div class="col">
										<div class="card-text thematic">{{ $t(thematic.name) }}</div>
									</div>
								</div>
								<p class="card-bottom">{{ thematic.description_1 }}<br />{{ thematic.description_2 }}
								</p>
							</div>
						</div>
					</a>
				</div>
			</flickity>
		</div>
	</div>
</template>

<script>
import Flickity from "vue-flickity";

export default {
	name: "thematicsCarousel",
	components: {
		Flickity,
	},
	props: {
		thematics: Array,
	},
	data() {
		return {
			flickityOptions: {
				initialIndex: 0,
				prevNextButtons: false,
				pageDots: false,
				wrapAround: false,
				draggable: false,
				cellAlign: "left",
			},
			textStyle: {
				"marginTop": "3rem",
				"marginBottom": "20px",
			},
			id: null,
		};
	},
	methods: {
		next() {
			this.$refs.flickity.next();
		},
		previous() {
			this.$refs.flickity.previous();
		},
		getThematicId(id) {
			this.id = id;
			this.thematics[id].isSelected = this.thematics[id].isSelected === false;
			for (let i = 0; i < this.thematics.length; i++) {
				if (i !== id) {
					this.thematics[i].isSelected = false;
				}
			}
		},
	},
};
</script>

<style scoped>
.carousel-cell {
	padding: 25px 20px;
}

.theme_card {
	background-color: #F7F7F7;
	color: #FFFFFF;
	border-radius: var(--big-border-radius);
	border: 0;
	overflow: hidden;
	width: 210px;
	height: 310px;
	padding: 0 5px;
}

.theme_card:hover {
	box-shadow: 0 0 15px #00000080;
}

.card-image {
	text-align: center;
	height: 160px;
	display: grid;
}

.card-text.thematic {
	color: var(--color-main-action);
	font-size: 22px;
	font-weight: bold;
}

a:hover,
a:focus,
a:active {
	text-decoration: none;
}

.card-image > img {
	align-self: center;
}

.card-bottom {
	color: #878787;
	font-size: 16px;
}

.card-action-custom {
	text-align: center;
}

.img_thematic {
	/*width: 150px;*/
	/*height: 150px;*/
}

.selected {
	outline: 3px solid var(--color-main-action);
}
</style>
